import React from 'react'

import {Box} from '@vio/atlas/helpers/Box'
import {SkeletonLoader} from '@vio/atlas/SkeletonLoader'

import {CheckInCheckOutProps} from './CheckInCheckOut'
import {PrimaryLoadingWrapper, SecondaryRow, Wrapper} from './styles'

export const CheckInCheckOutLoading: React.FC<
  Pick<CheckInCheckOutProps, 'layout'>
> = ({layout}) => {
  if (layout === 'secondary')
    return (
      <Wrapper>
        <Box display="flex" flexDirection="column" gap="s400" width="100%">
          <SecondaryRow>
            <SkeletonLoader width={58} />
            <SkeletonLoader width={58} marginTop={0} />
          </SecondaryRow>
          <SecondaryRow>
            <SkeletonLoader width={80} />
            <SkeletonLoader width={80} marginTop={0} />
          </SecondaryRow>
        </Box>
      </Wrapper>
    )
  return (
    <PrimaryLoadingWrapper>
      <div>
        <SkeletonLoader width={64} />
        <SkeletonLoader width={127} />
      </div>
      <div>
        <SkeletonLoader width={64} />
        <SkeletonLoader width={127} />
      </div>
    </PrimaryLoadingWrapper>
  )
}
